import { track, withContextualizedTracking } from 'lib/analytics'
import RegistryGiftGiverPage from './components/RegistryGiftGiverPage/RegistryGiftGiverPage'
import { AppliedSortsAndFiltersContextProvider } from './contexts'

const RegistryGiftGiverPageWrapper = () => (
  <AppliedSortsAndFiltersContextProvider>
    <RegistryGiftGiverPage />
  </AppliedSortsAndFiltersContextProvider>
)

export default withContextualizedTracking({
  eventLocation: track.EventLocation.REGISTRY,
})(RegistryGiftGiverPageWrapper)
